/**
 * Top-level app route paths. Use these instead of hardcoding path strings
 * in navigate / href / route definitions.
 */
export const AppRoutes = {
  HOME: '/',
  ONBOARDING: '/onboarding',
  QUIZ: '/quiz',
  CHECKOUT: '/checkout',
  ADDITIONAL_OFFERS: '/additional-offers',
  SUCCESS: '/success',
  REDIRECT: '/redirect',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  COOKIES: '/cookies',
} as const;

export type AppRoute = (typeof AppRoutes)[keyof typeof AppRoutes];
